import React from 'react';
import PropTypes from 'prop-types';

import { Alert, Snackbar } from '@cw-ui/feedback-components';
import { useI18nTranslation } from 'platform-i18n-utils';

import {
  I18N_KEYS,
  normalizeTicketId,
  SUBMIT_FAILURE_MESSAGE,
  SUBMIT_FAILURE_TITLE,
  SUBMIT_SUCCESS_MESSAGE_TEMPLATE,
  SUBMIT_SUCCESS_TITLE
} from '../../constants';

// @cw-ui toast width is 288px — wider so submit messages don't wrap awkwardly.
const TOAST_ALERT_SX = {
  width: { xs: 'calc(100vw - 32px)', sm: 480 },
  minWidth: { sm: 480 },
  maxWidth: 480
};

const TicketSubmissionToast = ({ outcome, open, onClose }) => {
  const { t } = useI18nTranslation();
  const isSuccess = outcome?.type === 'success';

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      role="status"
      aria-live="polite"
      data-testid="ticket-submission-toast"
    >
      <div>
        <Alert
          severity={isSuccess ? 'success' : 'error'}
          width="toast"
          title={
            isSuccess
              ? t(I18N_KEYS.SUBMIT_SUCCESS_TITLE, { defaultValue: SUBMIT_SUCCESS_TITLE })
              : t(I18N_KEYS.SUBMIT_FAILURE_TITLE, { defaultValue: SUBMIT_FAILURE_TITLE })
          }
          onClose={onClose}
          sx={TOAST_ALERT_SX}
        >
          {isSuccess
            ? t(I18N_KEYS.SUBMIT_SUCCESS_MESSAGE, {
                ticketId: normalizeTicketId(outcome.ticketId),
                defaultValue: SUBMIT_SUCCESS_MESSAGE_TEMPLATE
              })
            : t(I18N_KEYS.SUBMIT_FAILURE_MESSAGE, { defaultValue: SUBMIT_FAILURE_MESSAGE })}
        </Alert>
      </div>
    </Snackbar>
  );
};

TicketSubmissionToast.propTypes = {
  outcome: PropTypes.shape({
    type: PropTypes.oneOf(['success', 'failure']).isRequired,
    ticketId: PropTypes.string
  }),
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default TicketSubmissionToast;
